export default function CollapsibleSection({
  title, info, isExpanded, onToggle, children,
}) {
  const sectionId = `section-${title.replace(/\s+/g, "-").toLowerCase()}`;
  const buttonId = `${sectionId}-button`;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <button
        id={buttonId}
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between p-6 hover:bg-gray-50 transition-colors"
      >
        <h2 className="text-base font-semibold text-gray-900">{title}</h2>
        <div className="flex gap-4">
          {!!info && <span>{info}</span>}
          <svg
            className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${isExpanded ? "rotate-180" : ""
              }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </button>

      <div
        id={sectionId}
        role="region"
        aria-hidden={!isExpanded}
        className={`px-6 pb-6 border-t border-gray-200 pt-6 space-y-4 ${isExpanded ? "" : "hidden"
          }`}
      >
        {children}
      </div>
    </div>
  );
}
